import { Component } from "react";

// Catches any render/runtime error in the tree and shows a calm recovery card
// instead of a raw error screen. Protects the whole app.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[Xcelio ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center px-6 text-center" data-testid="error-boundary">
          <div className="max-w-sm">
            <div className="mx-auto mb-6 w-14 h-14 rounded-full bg-primary/15 flex items-center justify-center">
              <span className="text-2xl">✦</span>
            </div>
            <h1 className="font-serif text-3xl mb-3">Let's take a breath.</h1>
            <p className="text-sm text-muted-foreground mb-8">
              Something hiccuped for a moment. Nothing's lost — a quick refresh will bring you right back.
            </p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => { window.location.href = "/app"; }}
              className="rounded-full px-8 py-3 text-base bg-gradient-to-r from-blue-500 to-teal-400 text-white shadow-lg shadow-blue-500/20"
            >
              Back to Xcelio
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
